/** @jsxRuntime classic */ /** @jsx createElement */ import { createElement } from '@fluentui/react-jsx-runtime';
import { assertSlots } from '@fluentui/react-utilities';
/**
 * Render the final JSX of DialogActions
 */ export const renderDialogActions_unstable = (state)=>{
    assertSlots(state);
    // TODO Add additional slots in the appropriate place
    return /*#__PURE__*/ createElement(state.root, null);
};
